export default {
  title: 'Furnizori de livrare',
};
